import { Component, OnInit } from '@angular/core';
import { ExtensionDisplayType } from '../../../../../../models/ts/extension-display-type.model';
import { NgIf } from '@angular/common';
import { ExtensionIconComponent } from '../../../ui/icon/extension-icon/extension-icon.component';
import { CellActionType } from '../../../../../features/bizzmine/widgets/collection-list-widget/classes/cell-action-type';
import { GridCellBaseComponent } from '../grid-cell-base/grid-cell-base.component';
import { TitleFunctionType } from '../../../../../../models/ts/title-function-type.model';
import { VersionStateType } from 'src/models/ts/version-state-type.model';
import { GridContextPermissions } from 'src/app/features/bizzmine/widgets/collection-list-widget/classes/grid-context-permissions';
import { DirectEditMode } from 'src/models/ts/direct-edit-mode.model';
import { ProtectedFieldType } from '../../../../../../models/ts/protected-field-type.model';
import { CollectionFormField } from '../../../../../../models/ts/collection-form-field.model';
import { ChangeDetectionService } from 'src/app/core/services/change-detection/change-detection.service';

/**
 * Cell containing a file extension icon and text
 * Can contain both or either.
 */
@Component({
  selector: 'bizz-grid-cell-title',
  templateUrl: './grid-cell-title.component.html',
  styleUrls: ['./grid-cell-title.component.scss'],
  imports: [
    ExtensionIconComponent,
    NgIf
  ],
  standalone: true
})
export class GridCellTitleComponent extends GridCellBaseComponent<string> implements OnInit {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  protected readonly ExtensionDisplayType = ExtensionDisplayType;
  public linkEnabled = false;
  public isAvailableOffline: boolean | undefined = undefined;

  public ngOnInit(): void {
    this.apply();
  }
  
  private apply(): void {
    const isInGrid = this.metaData && this.metaData.formId != null && this.metaData.formId.trim() !== '';
    const canRead = <boolean><unknown>(this.data['Permissions']?.CanReadProperties);
    switch (this.column.TitleFunctionType) {
      case TitleFunctionType.ViewOnline:
        this.linkEnabled = (isInGrid && canRead && this.hasGridFileValue(this.data)) || (this.metaData && this.metaData.listOptions != undefined && this.metaData.listOptions.DirectEditMode !== DirectEditMode.Disabled && this.metaData.listOptions.DirectEditAdminConsented && !GridContextPermissions.hideDownload(this.data));
        break;
      case TitleFunctionType.Download:
        this.linkEnabled = (isInGrid && canRead && this.hasGridFileValue(this.data)) || !GridContextPermissions.hideDownload(this.data);
        break;
      case TitleFunctionType.ConsultRecord:
        this.linkEnabled = isInGrid || <boolean><unknown>(canRead || this.data['Permissions']?.CanReadDocPDF) && (this.data.CanReadDrafts || this.data.DocumentStatus == VersionStateType.Active || this.data.DocumentStatus === undefined);
        break;
      default:
        break;
    }
  }

  public hasGridFileValue(data: any): boolean {
    const fields = data?.Fields;
    if(fields){
      const collectionFormFields =  <Array<CollectionFormField>>fields;
      const file = collectionFormFields.find(_ => _.ProtectedFieldType == ProtectedFieldType.File);
      return file?.Value != null && file?.Value > 0;
    }
    return false;
}

  public override onDataChanged(): void {
    this.apply();
    ChangeDetectionService.detectChanges(this.changeDetectorRef);
  }

  public titleAction(mouseEvent: MouseEvent): void {
    const titleFunction = this.column.TitleFunctionType;
    switch (titleFunction) {
      case TitleFunctionType.ViewOnline:
        this.onCellAction.emit({
          mouseEvent: mouseEvent,
          action: CellActionType.VIEW_ONLINE,
          data: { data: this.data }
        });
        break;
      case TitleFunctionType.Download:
        this.onCellAction.emit({
          mouseEvent: mouseEvent,
          action: CellActionType.DOWNLOAD_FILE,
          data: { data: this.data }
        });
        break;
      case TitleFunctionType.ConsultRecord:
        this.onCellAction.emit({
          mouseEvent: mouseEvent,
          action: CellActionType.CONSULT_RECORD,
          data: { data: this.data }
        });
        break;
      default:
        break;
    }
  }
}
